import { render, staticRenderFns } from "./CheckboxSlider.vue?vue&type=template&id=27d79ba4&"
import script from "./CheckboxSlider.vue?vue&type=script&lang=js&"
export * from "./CheckboxSlider.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports